import { Product } from '@mc/api'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { BUNDLE_AD_LANDING_I18N_NAMESPACE, i18nInstance } from '../../../i18n'
import { components, getValues } from './common'

const t = i18nInstance.getFixedT(null, BUNDLE_AD_LANDING_I18N_NAMESPACE)

export const getBundlePricingSection = ({
  annualPass,
}: {
  annualPass: Product
}): Section => ({
  title: t('page.landing.faq.bundlePricing.title'),
  questions: [
    {
      title: t('page.landing.faq.bundlePricing.question1'),
      uuid: 'faq.bundlePricing.question1',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.bundlePricing.answer1'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
            values={getValues({ annualPass })}
          />
        </p>
      ),
    },
    {
      title: t('page.landing.faq.bundlePricing.question2'),
      uuid: 'faq.bundlePricing.question2',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.bundlePricing.answer2'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
            values={getValues({ annualPass })}
          />
        </p>
      ),
    },
    {
      title: t('page.landing.faq.bundlePricing.question3'),
      uuid: 'faq.bundlePricing.question3',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.bundlePricing.answer3'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
            values={getValues({ annualPass })}
          />
        </p>
      ),
    },
    {
      title: t('page.landing.faq.bundlePricing.question4'),
      uuid: 'faq.bundlePricing.question4',
      answer: (
        <p className='mc-opacity--hinted'>
          <Trans
            i18nKey='page.landing.faq.bundlePricing.answer4'
            ns={BUNDLE_AD_LANDING_I18N_NAMESPACE}
            components={components}
            values={getValues({ annualPass })}
          />
        </p>
      ),
    },
  ],
})
